"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.slashed_o = "ø";
exports.slashed_O = "Ø";
exports.slashedOUnicodeChart = {
    "o": exports.slashed_o,
    "O": exports.slashed_O
};
exports.slashedOUnicode = function (char) { return exports.slashedOUnicodeChart[char]; };
//# sourceMappingURL=slashed.js.map